/** @module store/plugins */
import { STORAGE_KEY } from '@/store/state'

/** Salva in localStorage lo stato dell'autenticazine e il listno corrente */
const localStoragePlugin = store => {
  store.subscribe((mutation, state) => {
    const syncedData = { auth: state.auth, currentListino: state.currentListino }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(syncedData))

    if (mutation.type === 'LOGOUT') {
      localStorage.removeItem(STORAGE_KEY)
    }
  })
}

export default [localStoragePlugin]


// WEBPACK FOOTER //
// ./src/store/plugins.js